module.exports = __webpack_public_path__ + "static/media/Profil.de0df202.jpg";